import { render, staticRenderFns } from "./PazienteParametriVitaliModalEditComponent.vue?vue&type=template&id=8d974e1e&scoped=true"
import script from "./PazienteParametriVitaliModalEditComponent.vue?vue&type=script&lang=js"
export * from "./PazienteParametriVitaliModalEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteParametriVitaliModalEditComponent.vue?vue&type=style&index=0&id=8d974e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d974e1e",
  null
  
)

export default component.exports